module.exports = __webpack_public_path__ + "img/2268.31c056f7.gif";